import React from "react";
import { Modal } from "antd";
import { Form } from "react-final-form";
import { useSelector, useDispatch } from "react-redux";

import { ContentLoader, FormField, FormFieldType } from "@components";
import { i18, required, translationGroups, trb } from "@utilities";
import { ApplicationsActions, selectIsReviewSanctionModalLoading } from "@redux";

const SANCTION_STATUS = {
  MATCHED: "Matched",
  FALSE_POSITIVE: "FalsePositive"
};

const SELECT_OPTIONS = [
  { value: SANCTION_STATUS.MATCHED },
  { value: SANCTION_STATUS.FALSE_POSITIVE }
];

export const ReviewSanctionModal = ({ onClose, sanction, appId }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsReviewSanctionModalLoading);

  const handleReviewSanctionSubmit = async values => {
    const data = {
      comment: values.comment,
      status: values.status,
      id: sanction.id,
      matchId: values.matched
    };
    await dispatch(
      ApplicationsActions.reviewSanction(data, appId, i18.NotificationTitles.SuccessOperation)
    );
    onClose();
  };

  return (
    <Form
      onSubmit={handleReviewSanctionSubmit}
      render={({ handleSubmit, values }) => {
        return (
          <Modal
            visible
            onOk={handleSubmit}
            onCancel={onClose}
            okText={trb(i18.Buttons.Ok)}
            cancelText={trb(i18.Buttons.Cancel)}
          >
            {isLoading ? (
              <ContentLoader />
            ) : (
              <form className="my-4" id="reviewSanction" onSubmit={handleSubmit}>
                <FormField
                  name="status"
                  component={FormFieldType.select}
                  options={SELECT_OPTIONS}
                  optionsLabel="value"
                  optionsValue="value"
                  size="large"
                  translate={translationGroups.SanctionStatus}
                  title={trb(i18.ApplicationsLabels.Status)}
                  validate={required}
                  className="mb-3"
                />
                {values.status === SANCTION_STATUS.MATCHED && (
                  <FormField
                    name="matched"
                    component={FormFieldType.select}
                    options={sanction.response.hits}
                    optionsLabel="score"
                    optionsValue="id"
                    title={trb(i18.ApplicationsLabels.Matched)}
                    validate={required}
                    size="large"
                    className="mb-3"
                  />
                )}
                <FormField
                  name="comment"
                  component={FormFieldType.input}
                  title={trb(i18.ApplicationsLabels.Comment)}
                  optionsLabel="value"
                  optionsValue="value"
                  translate={translationGroups.SanctionStatus}
                  validate={required}
                  size="large"
                  className="mb-3"
                />
              </form>
            )}
          </Modal>
        );
      }}
    />
  );
};
